import React, {
  FC, useEffect, useState,
} from 'react';
import PingFangMediumText from '../../../../components/Text/PingFangMediumText';
import Button from '../../../../components/Button';
import { getFoodifoxDataLazy } from '../../../../lib/axios/FoodifoxDataAPI';
import { User } from '../../../../lib/types';
import TermsConditionsModal from '../../Common/TermsConditionsModal';
import Loading from '../../../../components/Loading';
import InterBoldItalicText from '../../../../components/Text/InterBoldItalicText';
import InterItalicText from '../../../../components/Text/InterItalicText';
import CollectionRulesModal from '../../Common/CollectionRulesModal';

const ResidentBtn: FC<Props> = ({
  cabId,
  isEnglish,
  setTargetPage,
}) => {
  const [checkDriverTerms, { loading: checkDriverLoading }] = getFoodifoxDataLazy<User>('/foxH5User/hasCheckedTerms');

  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [showPromptModal, setShowPromptModal] = useState<boolean>(false);
  const [isAgreeTerms, setIsAgreeTerms] = useState<boolean>();
  const [showAgreeTermsBtn, setShowAgreeTermsBtn] = useState<boolean>(false);
  const [showTermsConditionsModal, setShowTermsConditionsModal] = useState<boolean>(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setShowLoading(checkDriverLoading);

    return () => {
      setShowLoading(false);
    };
  }, [checkDriverLoading]);

  useEffect(() => {
    if (isAgreeTerms) {
      // 进入注册用户页面
      setTargetPage('register-parcel-user');
      setIsAgreeTerms(undefined);
      // 同意协议后，设置本地缓存
      localStorage.setItem('user-agree-terms', 'Y');
    }
  }, [isAgreeTerms]);

  /**
   * 需要先同意条款与条件
   */
  const checkTerms = () => {
    // 同意领取规则后，设置本地缓存
    localStorage.setItem('user-agree-collection-rules', 'Y');
    //隐藏确认框
    setShowPromptModal(false);
    // 同意过协议，直接跳转到注册用户页面
    if (localStorage.getItem('user-agree-terms')) {
      setTargetPage('register-parcel-user');
      return;
    }
    // 没有确认协议时，弹出协议确认框
    setShowAgreeTermsBtn(true);
    setShowTermsConditionsModal(true);
  };

  return (
    <>
      {
        (showLoading) && (
          <Loading />
        )
      }
      {
        showPromptModal && (
          <CollectionRulesModal
            onClose={() => {
              setShowPromptModal(false);
            }}
            callback={() => {
              checkTerms();
            }}
            isEnglish={isEnglish}
          />
        )
      }
      {
        showTermsConditionsModal && (
          <TermsConditionsModal
            callback={(isAgree) => {
              setIsAgreeTerms(isAgree);
              setShowTermsConditionsModal(false);
            }}
            showAgreeBtn={showAgreeTermsBtn}
            showExitBtn={showAgreeTermsBtn}
            isEnglish={isEnglish}
          />
        )
      }
      <Button
        minWidth={190}
        maxWidth={190}
        minHeight={190}
        maxHeight={190}
        backgroundColor={'#15274E'}
        borderRadius={'50%'}
        marginTop={19}
        style={{ border: '2px solid #000000', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
        onClick={() => {
          // 同意过领取规则，直接跳转到注册用户页面
          if (localStorage.getItem('user-agree-collection-rules')) {
            setTargetPage('register-parcel-user');
            return;
          }
          else {
            // 指定柜子不需要显示领取规则弹窗，直接进入下一步
            if ([87, 88].includes(cabId)) {
              checkTerms();
            }
            else {
              setShowPromptModal(true);
            }
          }
        }}
      >
        {
          isEnglish ? (
            <>
              <InterBoldItalicText color={'#FFFFFF'} fontSize={24} marginTop={5}>
                Residents
              </InterBoldItalicText>
              <InterItalicText color={'#FFFFFF'} fontSize={16} marginTop={-3}>
                Sign Up & Pick Up
              </InterItalicText>
            </>
          ) : (
            <>
              <PingFangMediumText color={'#FFFFFF'} fontSize={24} marginTop={8}>
                住户注册&取餐
              </PingFangMediumText>
            </>
          )
        }
      </Button>
    </>
  );
};

export interface Props {
  cabId: number;
  isEnglish: boolean;
  setTargetPage: (targetPage: string) => void;
}

export default ResidentBtn;
